import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-history-years-type',
  templateUrl: './history-years-type.component.html',
  styleUrls: ['./history-years-type.component.scss']
})
export class HistoryYearsTypeComponent  extends FieldType<FieldTypeConfig> implements OnInit {

  ngOnInit(): void {
  }

  radioChange(event) {
    console.log(this.field.formControl.value)
  }
}
